import { isDefined } from 'notable-common';
import { reservedFlowBlockNames } from './keywords.js';
export var FlowBlockValueTemplateHint;
(function (FlowBlockValueTemplateHint) {
    FlowBlockValueTemplateHint["Valid"] = "Valid";
    FlowBlockValueTemplateHint["Invalid"] = "Invalid";
    FlowBlockValueTemplateHint["NotTemplateLike"] = "NotTemplateLike";
})(FlowBlockValueTemplateHint || (FlowBlockValueTemplateHint = {}));
/**
 * Allow only notable variable names.
 * Examples:
 * - {{blockName.data}}
 * - {{blockName.data.field}}
 * - {{blockName.data.field[0]}}
 * - {{blockName.data.field[0].nestedField}}
 * - {{blockName.data.field[0].['nested Field with spaces']}}
 * - {{inputs.something}}
 */
export function validateFlowBlockValueTemplate(value) {
    if (!value.startsWith('{{') && !value.endsWith('}}')) {
        return {
            hint: FlowBlockValueTemplateHint.NotTemplateLike,
        };
    }
    if (value.startsWith('{{') !== value.endsWith('}}')) {
        return {
            hint: FlowBlockValueTemplateHint.Invalid,
            message: 'Template must have matching braces. e.g. {{blockName.data}}',
        };
    }
    const innerContent = value.slice(2, -2).trim();
    const parts = innerContent.split('.');
    if (parts.length < 2 && !reservedFlowBlockNames.includes(innerContent)) {
        return {
            hint: FlowBlockValueTemplateHint.Invalid,
            message: 'Template must have at least two parts. e.g. {{blockName.data}}',
        };
    }
    const [blockName = '', secondField = ''] = parts;
    const hasBlockName = !reservedFlowBlockNames.includes(blockName);
    const rest = parts.slice(hasBlockName ? 2 : 1);
    if (hasBlockName) {
        if (!/^\w+$/.test(blockName)) {
            return {
                hint: FlowBlockValueTemplateHint.Invalid,
                message: 'Template must be a valid block name. e.g. {{blockName.data}}',
            };
        }
        const secondFieldMatch = /^(data|error)(\[\d+\]|\[(["']).*?\3\])?$/.exec(secondField);
        if (!isDefined(secondFieldMatch)) {
            return {
                hint: FlowBlockValueTemplateHint.Invalid,
                message: 'Template must be a valid data or error reference. e.g. {{blockName.data.field}}',
            };
        }
    }
    for (const part of rest) {
        const partMatch = /^\w+(\[\d+\]|\[(["']).*?\2\])?$/.exec(part);
        if (!isDefined(partMatch)) {
            return {
                hint: FlowBlockValueTemplateHint.Invalid,
                message: 'Template must have a valid field name, array index, or key index. e.g. {{block.data.field}} {{blockName.data.field[0]}}',
            };
        }
    }
    return {
        hint: FlowBlockValueTemplateHint.Valid,
    };
}
//# sourceMappingURL=template.js.map